import { LinkButton } from '@pmi/dsm-react';
import CustomAlert from '../CustomAlert';
import { AlertMessage } from '../models';
import styles from './UsersFailedInvitationsAlert.module.scss';
import userAdminNavigate from '../../../hooks/userAdminNavigate';

export default function UsersFailedInvitationsAlert({
  message,
  onAlertClose,
}: {
  message: AlertMessage;
  onAlertClose: (alert: AlertMessage) => void;
}) {
  const { navigate } = userAdminNavigate();

  const handleViewLinkClick = () => {
    navigate(`people?statuses=Failed`);
  };

  return (
    <CustomAlert message={message} onAlertClose={onAlertClose}>
      <div className="d-flex align-items-center">
        {message.data.failed_users_count === 1 && (
          <span>
            Error! 1 email invitation was undeliverable to the recipient.
          </span>
        )}
        {message.data.failed_users_count > 1 && (
          <span>
            Error! {message.data.failed_users_count} email invitations were
            undeliverable to the recipient.
          </span>
        )}
        <LinkButton
          titleText="Click here to view"
          size="md"
          className={styles.linkButton}
          onClick={handleViewLinkClick}
        />
      </div>
    </CustomAlert>
  );
}
